import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import WhereToBuyModal from './Components/WhereToBuyModal';

export default function AdminWhereToBuy()
{
    const [
        whereToBuys,
        setWhereToBuys
    ] = useState<any[]>([]);

    const [
        modalOpen,
        setModalOpen
    ] = useState(false);

    const [
        selectedWhereToBuy,
        setSelectedWhereToBuy
    ] = useState<any>(null);

    const loadWhereToBuys = async () => {

        const response =
            await api.get(
                '/where-to-buy'
            );

        setWhereToBuys(
            response.data
        );
    };

    useEffect(() => {

        loadWhereToBuys();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedWhereToBuy
        ) {

            await api.post(

                `/where-to-buy/${selectedWhereToBuy.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/where-to-buy',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedWhereToBuy(
            null
        );

        loadWhereToBuys();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this retailer?'
            )
        ) {
            return;
        }

        await api.delete(
            `/where-to-buy/${id}`
        );

        loadWhereToBuys();
    };

    const moveRetailerUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...whereToBuys];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setWhereToBuys(
            updated
        );

        await api.post(
            '/reorder-where-to-buy',
            {
                retailers:
                    updated.map(
                        (
                            retailer,
                            position
                        ) => ({
                            id:
                            retailer.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadWhereToBuys();
    };

    const moveRetailerDown = async (
        index: number
    ) => {

        if (
            index >=
            whereToBuys.length - 1
        ) {
            return;
        }

        const updated =
            [...whereToBuys];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setWhereToBuys(
            updated
        );

        await api.post(
            '/reorder-where-to-buy',
            {
                retailers:
                    updated.map(
                        (
                            retailer,
                            position
                        ) => ({
                            id:
                            retailer.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadWhereToBuys();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Where To Buy
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedWhereToBuy(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Retailer
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Retailer
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {whereToBuys.map(
                    (
                        retailer,
                        index
                    ) => (

                        <tr
                            key={
                                retailer.id
                            }
                        >

                            <td>
                                {
                                    retailer.retailer_name
                                }
                            </td>

                            <td>
                                {
                                    retailer.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRetailerUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRetailerDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedWhereToBuy(
                                                retailer
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                retailer.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <WhereToBuyModal

                    whereToBuy={
                        selectedWhereToBuy
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
